<template>
  <section class="qv-card">
    <p class="qv-section-title">Análise de Vendas</p>

    <div class="qv-stat-row" v-if="loading">
      <div class="qv-stat" v-for="n in 3" :key="'sa-' + n">
        <span class="qv-sk qv-sk-label"></span>
        <span class="qv-sk qv-sk-value"></span>
        <span class="qv-sk qv-sk-sub"></span>
      </div>
    </div>

    <div class="qv-stat-row" v-else>
      <div
        v-for="analysis in salesAnalysis"
        :key="analysis.period"
        class="qv-stat"
      >
        <span class="qs-label">{{ analysis.period }}</span>
        <span class="qs-value">
          {{ analysis.average }}
          <span class="u">un/dia</span>
        </span>
        <span class="qs-sub">{{ analysis.total }} un vendidos</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
    name: 'QvSalesAnalysis',

    props: {
        salesAnalysis: {
            type: Array,
            default: () => [],
        },

        loading: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
@import './_qv-shared.scss';
</style>
